import { extend } from "flarum/common/extend";
import app from "flarum/app";
import LinkButton from "flarum/common/components/LinkButton";
import UserPage from "flarum/forum/components/UserPage";
import ProfessionalAchievementsPane from "../panes/ProfessionalAchievementsPane";

export default function () {
  app.routes["tolyod-advcomments-professional-achievements-view-profile"] = {
    path: "/professional_achievements/:id",
    component: ProfessionalAchievementsPane,
  };
  extend(UserPage.prototype, "navItems", function (items) {
    const href = app.route(
      "tolyod-advcomments-professional-achievements-view-profile",
      {
        id: this.user.id(),
      }
    );
    // console.log(items.get("masquerade")['attrs']["href"]);
    items.add(
      "professional_achievements",
      LinkButton.component(
        {
          href,
          icon: "fa fa-trophy",
        },
        app.translator.trans("tolyod-advdiscus.forum.user_profile.professional_achievements")
      ),
      300
    );
  });
}
